export default __webpack_public_path__ + "static/media/11.c010d22b.jpg";